"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SelectableOption_types_1 = require("../../utilities/selectableOption/SelectableOption.types");
exports.DropdownMenuItemType = SelectableOption_types_1.SelectableOptionMenuItemType;
//# sourceMappingURL=Dropdown.types.js.map